/**
 * @fileoverview Играбельный runtime: Session + Canvas + DomShell.
 */

import markup from "@/ui/dom/shell.html?raw";
import { spawnPlane } from "@/game/plane/spawn";
import { CanvasRenderer } from "@/game/render/CanvasRenderer";
import { Session } from "@/game/session/Session";
import { bindCanvasInput } from "@/game/input/canvasInput";
import { DomShell } from "@/ui/dom/DomShell";

export interface BootHandle {
  dispose(): void;
}

/**
 * Вставить разметку HUD и запустить симуляцию + презентационный цикл.
 */
export function bootTypeScriptGame(host: HTMLElement): BootHandle {
  host.innerHTML = markup;
  const root = host;
  const session = new Session();
  const renderer = new CanvasRenderer(root);
  renderer.attach();

  const shell = new DomShell(root, session, (tutorial) => {
    const hooks = shell.hooks();
    hooks.track = (x, y, r) => renderer.tracks.track(x, y, r);
    hooks.plowTrack = (x, y, w) => renderer.tracks.plow(x, y, w);
    session.start(hooks, tutorial);
    renderer.tracks.clear();
    if (tutorial) {
      const g = session.g!;
      spawnPlane(g, hooks, "jet", false, true);
      const p = g.planes[0]!;
      shell.selectPlane(p);
    }
  });
  shell.bind();

  const hooks = shell.hooks();
  hooks.track = (x, y, r) => renderer.tracks.track(x, y, r);
  hooks.plowTrack = (x, y, w) => renderer.tracks.plow(x, y, w);

  const cv = root.querySelector<HTMLCanvasElement>("#game")!;
  const unbindInput = bindCanvasInput(
    cv,
    session,
    renderer,
    shell,
    hooks,
    root,
  );

  let last = performance.now();
  let raf = 0;
  let alive = true;

  const frame = (now: number): void => {
    if (!alive) return;
    let dt = (now - last) / 1000;
    last = now;
    if (dt > 0.06) dt = 0.06;
    const t = now / 1000;

    // Обновлять hooks каждый кадр (замыкания toast/endGame остаются валидными)
    const h = shell.hooks();
    h.track = (x, y, r) => renderer.tracks.track(x, y, r);
    h.plowTrack = (x, y, w) => renderer.tracks.plow(x, y, w);
    session.tick(h, dt);

    renderer.paint(session.g, session.cam, session.selected, dt, t);
    shell.tickHud(dt, session.frontLabel);
    raf = requestAnimationFrame(frame);
  };
  raf = requestAnimationFrame(frame);

  return {
    dispose() {
      alive = false;
      cancelAnimationFrame(raf);
      unbindInput();
      shell.dispose();
      renderer.dispose();
    },
  };
}
